import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import FanPermissions from "./OnboardTab/FanPermissions";
import OnboardOptions from "./OnboardTab/OnboardOptions";
import SuperAdminContainer from "../../../superAdmin/SuperAdminContainer";
import { ScreenHeader, TabNav } from "../../../../CommonComponents";

const Onboard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getCurrentTab = () => {
    if (location.pathname.includes("/pending")) {
      return "pending";
    }
    if (location.pathname.includes("/fan")) {
      return "fan";
    }
    return "onboardMembers";
  };

  const menuItems = [
    {
      key: "onboardMembers",
      label: "Onboard",
    },
    {
      key: "fan",
      label: "Fan Permissions",
    },
  ];

  const handleTabChange = (tabKey) => {
    switch (tabKey) {
      case "onboardMembers":
        navigate("/admin/members/onboard");
        break;
      case "pending":
        navigate("/admin/members/onboard/pending");
        break;
      case "fan":
        navigate("/admin/members/onboard/fan");
        break;
      default:
        navigate("/admin/members/onboard");
    }
  };

  const renderContent = () => {
    // if (location.pathname.includes("/pending")) {
    //   return <PendingMembers />;
    // }

    if (location.pathname.includes("/fan")) {
      return <FanPermissions />;
    }

    return <OnboardOptions handleTabChange={handleTabChange} />;
  };

  return (
    <SuperAdminContainer>
      <ScreenHeader title="Onboard" style={{ marginBottom: "2px" }} />
      <div>
        <TabNav
          items={menuItems}
          activeKey={getCurrentTab()}
          handleTabChange={handleTabChange}
        />
      </div>

      <div style={{ marginTop: "2px" }}>{renderContent()}</div>
    </SuperAdminContainer>
  );
};

export default Onboard;
